import { render, staticRenderFns } from "./VisibleSwitcher.vue?vue&type=template&id=09a6615b"
import script from "./VisibleSwitcher.vue?vue&type=script&lang=js"
export * from "./VisibleSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports